import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Drawer, Dropdown } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import Logo from "./Logo";
import services from "../../data/services.json";
import {
  HeaderSection,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Outline,
  Span,
  Phone,
  Cta,
  Bar,
  LogoLink,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const toggleButton = () => setVisibility(!visible);

  // En la home la cabecera usa una superficie translúcida sobre el hero.
  const { pathname } = useLocation();
  const overlay = pathname === "/" || pathname === "/home";

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    // Fuera de la portada no hay #cotizador: se va a la página del cotizador
    // (2026-10-14; antes el enlace no hacía nada en servicios y ciudades).
    else if (id === "cotizador") window.location.assign("/cotizador");
    setVisibility(false);
  };

  const servicesMenu = {
    items: services.map((s: { name: string; slug: string }) => ({
      key: s.slug,
      label: (
        <a
          href={`/servicios/${s.slug}`}
          style={{ color: "#111c44", fontSize: "0.92rem", textDecoration: "none" }}
        >
          {s.name}
        </a>
      ),
    })),
  };

  const NavItems = () => (
    <>
      <Dropdown menu={servicesMenu} placement="bottomLeft" trigger={["hover", "click"]}>
        <CustomNavLinkSmall>
          <Span>{t("Services")} ▾</Span>
        </CustomNavLinkSmall>
      </Dropdown>
      <CustomNavLinkSmall onClick={() => scrollTo("operadores")}>
        <Span>{t("Operators")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("cotizador")}>
        <Span>Cotizador</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("ciudades")}>
        <Span>{t("Cities")}</Span>
      </CustomNavLinkSmall>
      <Phone href="tel:+34962403354">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
        962 40 33 54
      </Phone>
      <Cta href="/cotizador">
        {t("Register")}
      </Cta>
    </>
  );

  return (
    <HeaderSection $overlay={overlay}>
      <Container>
        <Bar>
          <LogoLink href="/" aria-label="Empresas de Transporte Albacete">
            <Logo />
          </LogoLink>

          <NotHidden>
            <NavItems />
          </NotHidden>

          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Bar>

        <Drawer closable={true} open={visible} onClose={toggleButton} title="Menú">
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <NavItems />
          </div>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
